import { Table, TableProps, Box, useColorModeValue } from "@chakra-ui/react";
import React from "react";

const ResponsiveTable: React.FC<TableProps> = (props) => {
  const { children, ...rest } = props;
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const hoverBgColor = useColorModeValue("gray.50", "gray.700");

  return (
    <Box
      overflowX="auto"
      borderRadius="lg"
      width="full"
      sx={{
        '&::-webkit-scrollbar': {
          height: '8px',
          borderRadius: '8px',
          backgroundColor: useColorModeValue('gray.100', 'gray.700'),
        },
        '&::-webkit-scrollbar-thumb': {
          borderRadius: '8px',
          backgroundColor: useColorModeValue('gray.300', 'gray.600'),
        },
        'tr': {
          transition: 'all 0.2s ease',
        },
        'tbody tr:hover': {
          bg: hoverBgColor,
          transform: 'scale(1.01)',
          boxShadow: 'sm',
        },
        'th': {
          textTransform: 'uppercase',
          letterSpacing: 'wider',
          fontSize: 'xs',
          fontWeight: 'bold',
          padding: '12px 16px',
        },
        'td': {
          padding: '16px',
          borderColor: borderColor,
        }
      }}
    >
      <Table
        variant="simple"
        size="md"
        {...rest}
      >
        {children}
      </Table>
    </Box>
  );
};

export default ResponsiveTable;